import { __awaiter } from "tslib";
import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import { ReducerType } from './types';
import { makeImageMap } from '@open-tender/utils';
const makeTagLookup = (data) => {
    return data.reduce((obj, i) => {
        const imageMap = i.images ? makeImageMap(i.images) : {};
        const imageUrl = imageMap.SMALL_IMAGE || imageMap.APP_IMAGE || imageMap.LARGE_IMAGE || '';
        const tag = Object.assign(Object.assign({}, i), { imageUrl });
        return Object.assign(Object.assign({}, obj), { [i.name]: tag });
    }, {});
};
const initialState = {
    entities: [],
    error: null,
    loading: 'idle',
    selectedTags: [],
    lookup: {}
};
export var TagsActionType;
(function (TagsActionType) {
    TagsActionType["FetchTags"] = "tags/fetchTags";
})(TagsActionType || (TagsActionType = {}));
export const fetchTags = createAsyncThunk(TagsActionType.FetchTags, (_, { getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const api = getState().config.api;
        const { data } = yield api.getTags();
        const lookup = makeTagLookup(data);
        return { data, lookup };
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const tagsSlice = createSlice({
    name: ReducerType.Tags,
    initialState,
    reducers: {
        resetTags: () => initialState,
        setSelectedTags: (state, action) => {
            state.selectedTags = action.payload;
        },
        toggleTag: (state, action) => {
            const tag = action.payload;
            const exists = state.selectedTags.find(i => i.tag_id === tag.tag_id);
            state.selectedTags = exists
                ? state.selectedTags.filter(i => i.tag_id !== tag.tag_id)
                : [...state.selectedTags, tag];
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchTags.fulfilled, (state, action) => {
            state.entities = action.payload.data;
            state.lookup = action.payload.lookup;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(fetchTags.pending, state => {
            state.loading = 'pending';
        })
            .addCase(fetchTags.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        });
    }
});
export const { resetTags, setSelectedTags, toggleTag } = tagsSlice.actions;
export const selectTags = (state) => state.tags;
export const selectSelectedTags = (state) => state.tags.selectedTags;
export const selectSelectedTagNames = createSelector((state) => {
    const { entities: tags, selectedTags } = state.tags;
    return { tags, selectedTags };
}, ({ tags, selectedTags }) => {
    if (!selectedTags)
        return [];
    const selected = selectedTags.map(i => {
        var _a;
        const tag = tags.find(a => a.tag_id === i.tag_id);
        return tag ? (_a = tag.name) !== null && _a !== void 0 ? _a : '' : '';
    });
    return selected;
});
export const tagsReducer = tagsSlice.reducer;
